import { useMutation } from '@tanstack/react-query';
import { getProductModelByFiltersAndLimit } from 'services/api/requests/productModel';
import { IAutocomplete } from 'utils/forms/autocomplete';

export const useProductModelListAsMutate = ({
	busca,
	limit,
	orderBy = 'nome_modelo',
	sort = 'ASC',
	produtos_status,
}: IAutocomplete) => {
	return useMutation(() =>
		getProductModelByFiltersAndLimit(
			busca,
			limit,
			orderBy,
			sort,
			produtos_status
		)
	);
};
